import React from 'react';
import { Link } from 'react-router-dom';
import { Article } from '@/types/article';
import { formatPublishDate } from '@/utils/articleUtils';

interface ArticleHeaderProps {
  article: Article;
}

const ArticleHeader: React.FC<ArticleHeaderProps> = ({ article }) => {
  return (
    <header className="mb-10">
      <div className="flex flex-wrap gap-3 mb-4">
        {article.categories.map(category => (
          <Link 
            key={category.id} 
            to={`/categories/${category.slug}`}
            className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium hover:bg-blue-200"
          >
            {category.name}
          </Link>
        ))}
      </div>
      <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">{article.title}</h1>
      <div className="flex items-center mb-6">
        <div className="flex items-center">
          <img
            src={article.author.avatar || "https://via.placeholder.com/40"}
            alt={article.author.name}
            className="w-10 h-10 rounded-full mr-3"
          />
          <div>
            <p className="font-medium text-gray-900">{article.author.name}</p>
            <div className="flex items-center text-gray-500 text-sm">
              <span>{formatPublishDate(article.publishedAt)}</span>
              <span className="mx-2">•</span>
              <span>{article.readTime} min read</span>
            </div>
          </div>
        </div>
      </div>
      {article.featuredImage ? (
        <div className="rounded-xl overflow-hidden mb-8">
          <img 
            src={article.featuredImage}
            alt={article.title}
            className="w-full h-auto"
          />
        </div>
      ) : (
        <div className="rounded-xl overflow-hidden mb-8">
          <img 
            src="/placeholder.jpg"
            alt="Placeholder"
            className="w-full h-auto"
          />
        </div>
      )}
    </header>
  );
};

export default ArticleHeader; 